module.exports = __webpack_public_path__ + "assets/img/1591951049681.dd16251d.png";